import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";

/**
 * Single row inside NtSetupResourceList — mono badge + title/subtitle +
 * optional trailing label. Rows render as siblings inside a unified list card
 * (the parent applies the surrounding border / radius / dividers).
 */
function NtSetupResourceCard({ badge, title, subtitle, trailing, last }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <View style={[styles.row, last && styles.rowLast]}>
      {badge ? (
        <View style={styles.badge}>
          <NtText style={styles.badgeText}>{badge}</NtText>
        </View>
      ) : null}
      <View style={{ flex: 1 }}>
        {title ? <NtText style={styles.title}>{title}</NtText> : null}
        {subtitle ? <NtText style={styles.subtitle}>{subtitle}</NtText> : null}
      </View>
      {trailing ? <NtText style={styles.trailing}>{trailing}</NtText> : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    row: {
      flexDirection: "row",
      alignItems: "center",
      gap: 12,
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderBottomWidth: 1,
      borderBottomColor: t.borderSoft,
    },
    rowLast: { borderBottomWidth: 0 },
    badge: {
      paddingVertical: 5,
      paddingHorizontal: 10,
      backgroundColor: t.surface3,
      borderWidth: 1,
      borderColor: t.border,
      borderRadius: t.radius,
      minWidth: 60,
      alignItems: "center",
    },
    badgeText: {
      fontFamily: "Menlo",
      fontSize: 12,
      fontWeight: "700",
      color: t.text,
    },
    title: { fontSize: 13, color: t.text, fontWeight: "600" },
    subtitle: { fontSize: 12, color: t.textDim, marginTop: 2 },
    trailing: {
      fontSize: 11,
      color: t.textMute,
      textTransform: "uppercase",
      letterSpacing: 0.4,
      fontWeight: "700",
    },
  });

export default NtSetupResourceCard;
